import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import GetAppIcon from '@mui/icons-material/GetApp';

import UserService from "services/UserService";
import axios from "axios";
import { getMBMIotdevices } from "services/ConfigServices";
import { iotdevicetext } from "variables/MBM/iotdevices";
import { definitionData, eosprotocoleData } from "variables/MBM/lists/iotdevices";
import moment from "moment";

import { downloadCSV } from "utilities/exporttabletocsv";
import Button from "components/CustomButtons/Button.js";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function useIotDevicesTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbmadmin = permis.includes("mbmadmin");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getMBMIotdevices(chartIdGroup);
  const [results, setResults] = useState({ meters: [] });
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [iotdevicesdata, setIotdevicesData] = useState([]);
  const [iotdevices, setIotdevices] = useState([]);

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setIotdevicesData(response.data.iotdevices);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = _.get(results, `iotdevices`, []).filter(
    (item) =>
      (item.name && item.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.connectionproperties?.deveui && item.connectionproperties?.deveui.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.definition && definitionData.find((x) => x.id == item.definition) && definitionData.find((x) => x.id == item.definition).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.definition && definitionData.find((x) => x.id == item.definition) && definitionData.find((x) => x.id == item.definition).category.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.groupid && groupInfoListById["" + item.groupid] && groupInfoListById["" + item.groupid].toLowerCase().includes(filterText.toLowerCase())) ||
      (item.connectionproperties?.eosprotocol && eosprotocoleData.find((x) => x.id == item.connectionproperties.eosprotocol) && eosprotocoleData.find((x) => x.id == item.connectionproperties.eosprotocol).name.toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = iotdevices.map((item) => {
      let iotdevicetoexport = {};
      iotdevicetoexport[iotdevicetext.id] = item.id;
      iotdevicetoexport[iotdevicetext.name] = item.name;
      iotdevicetoexport[iotdevicetext.definition] = definitionData.find((x) => x.id == item.definition)?.name;
      iotdevicetoexport[iotdevicetext.category] = definitionData.find((x) => x.id == item.definition)?.category;
      iotdevicetoexport[iotdevicetext.group] = groupInfoListById["" + item.groupid];
      iotdevicetoexport[iotdevicetext.eosprotocol] = eosprotocoleData.find((x) => x.id == item.connectionproperties?.eosprotocol)?.name;
      return iotdevicetoexport;
    });
    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {mbmadmin && (
          <>
            <UploadButton type="button" onClick={handleClear}>
              {/* <AddMeters refetch={refreshTable} onClick={handleClear} marketmeters={marketmeters} /> */}
            </UploadButton>
            <UploadButton type="button" onClick={handleClear}>
              {/* <EditMeters refetch={refreshTable} onClick={handleClear} marketmeters={marketmeters} disabled={!marketmeters || marketmeters.length < 1} /> */}
            </UploadButton>
            <UploadButton type="button" onClick={handleClear}>
              {/* <DeleteMeters refetch={refreshTable} onClick={handleClear} marketmeters={marketmeters} disabled={!marketmeters || marketmeters.length < 1} /> */}
            </UploadButton>
          </>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!iotdevices || iotdevices.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, iotdevicesdata, iotdevices]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setIotdevices
  };
}
